import { DeviceNetworkInterfaces, EventBase } from "@vp/models";

export interface DeviceNetworkInterfacesNotificationEventArgs {
  deviceUserId: string;
  deviceNetworkInterfaces: DeviceNetworkInterfaces;
}

export class DeviceNetworkInterfacesUpdatedEvent extends EventBase<DeviceNetworkInterfacesNotificationEventArgs> {
  constructor(args: DeviceNetworkInterfacesNotificationEventArgs) {
    super();
    this.args = args;
  }
}
